"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M11.2255 3.134c.0699.504.0745 1.082-.2374 1.776-.112.2492-.1166.421-.0805.6813a6.059 6.059 0 0 0 .0357.2119c.0518.2906.1327.7436.1327 1.1968h-2c0-.2656-.0315-.4393-.0736-.6715-.0232-.128-.0497-.2737-.0759-.4625-.0699-.504-.0745-1.082.2374-1.776.112-.2492.1166-.421.0805-.6813a6.0982 6.0982 0 0 0-.0357-.212C9.157 2.9063 9.076 2.4533 9.076 2h2c0 .2656.0315.4393.0736.6715.0233.128.0497.2738.0759.4625z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0937 8H5.502l2 14h8.5917l.7346-5.1423h.97c1.9724 0 3.5714-1.599 3.5714-3.5714 0-1.9556-1.5718-3.5442-3.521-3.5711L18.0937 8zm-.5307 3.7148-.449 3.1429h.6843c.8678 0 1.5714-.7036 1.5714-1.5714 0-.8679-.7036-1.5715-1.5714-1.5715h-.2353zM9.2365 20 7.808 10h7.9797l-1.4286 10H9.2365z"
  }), _react.default.createElement("path", {
    d: "M14.6857 4.91c.3022-.6724.292-1.2524.2292-1.7441a11.7673 11.7673 0 0 0-.0695-.461c-.0404-.2436-.0718-.4324-.0718-.7049h-2c0 .4444.0731.8914.122 1.1902.0151.092.0278.17.0354.2294.0367.2868.0266.4567-.0695.6705-.3022.6723-.292 1.2524-.2291 1.744.0235.1837.0478.3302.0695.461.0404.2435.0717.4324.0717.7049h2c0-.4444-.0731-.8914-.122-1.1902-.015-.092-.0278-.1699-.0354-.2294-.0367-.2868-.0265-.4567.0695-.6705z"
  })];
};

exports.default = _default;